import { render, staticRenderFns } from "./stats.stock-optimization.vue?vue&type=template&id=6d57186f&scoped=true&"
import script from "./stats.stock-optimization.vue?vue&type=script&lang=js&"
export * from "./stats.stock-optimization.vue?vue&type=script&lang=js&"
import style0 from "./stats.stock-optimization.vue?vue&type=style&index=0&id=6d57186f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d57186f",
  null
  
)

export default component.exports